// extracted by mini-css-extract-plugin
module.exports = {"warning":"BugReason_warning__3e3VH"};